export default {
    columns: [
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.workday.id.description", //"Código interno jornada",
          label: "wkt.admin.qbuilder.model.workday.id.text",  //"Código jornada",
          field: "id"
        },
        {
          field: "calendarDay",
          type: "SIMPLEDATE",
          desc: "wkt.admin.qbuilder.model.workday.calendar-day.description", //"Fecha de la jornada",
          label: "wkt.admin.qbuilder.model.workday.calendar-day.text",  //"F. Jornada",
          formatter: 'formatSimpleDate'
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.workday.employee-id.description", //"Código interno trabajador",
          label: "wkt.admin.qbuilder.model.workday.employee-id.text",  //"Código trabajador",
          field: "employeeId"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.workday.firstname.description", //"Nombre",
          label: "wkt.admin.qbuilder.model.workday.firstname.text",  //"Nombre",
          field: "firstname"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.workday.lastname.description", //"Apellidos",
          label: "wkt.admin.qbuilder.model.workday.lastname.text",  //"Apellidos",
          field: "lastname"
        },
                {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.workday.id-number.description", //"Documento identificativo",
          label: "wkt.admin.qbuilder.model.workday.id-number.text",  //"Documento ID",
          field: "idNumber"
        },
        {
          field: "username",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.workday.username.description", //"Nombre de usuario",
          label: "wkt.admin.qbuilder.model.workday.username.text",  //"Usuario"
        },
        {
          field: "externalId",
          type: "CHARACTER",
          desc:"wkt.admin.qbuilder.model.activity.employee-reference.description",//"Referencia del trabajador",
          label:"wkt.admin.qbuilder.model.activity.employee-reference.text",//"Referencia trabajador"
        },
        {
          field: "workplaceId",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.workday.workplace-id.description", //"Código del centro de trabajo",
          label: "wkt.admin.qbuilder.model.workday.workplace-id.text",  //"Código centro trabajo"
        },
        {
          field: "workplaceName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.workday.workplace-name.description", //"Nombre Centro de trabajo",
          label: "wkt.admin.qbuilder.model.workday.workplace-name.text",  //"Centro trabajo"
        },
        {
          field: "departmentId",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.workday.department-id.description", //"Código del departamento",
          label: "wkt.admin.qbuilder.model.workday.department-id.text",  //"Código departamento"
        },
        {
          field: "departmentName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.workday.department-name.description", //"Nombre Departamento",
          label: "wkt.admin.qbuilder.model.workday.department-name.text",  //"Departamento"
        },
		{
          field: "dayType",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.workday.day-type.description",
          label: "wkt.admin.qbuilder.model.workday.day-type.text",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.qbuilder.model.workday.day-type.regular'},
                     { 'key':'1', 'value':'wkt.admin.qbuilder.model.workday.day-type.rest'} ,
                     { 'key':'2', 'value':'wkt.admin.qbuilder.model.workday.day-type.national_holiday'} ,
                     { 'key':'3', 'value':'wkt.admin.qbuilder.model.workday.day-type.local_holiday'} ,
                     { 'key':'4', 'value':'wkt.admin.qbuilder.model.workday.day-type.company_holiday'} ]
        },
        {
          field: "totalWorkHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.total-work-hours.description",//"Horas objetivo a trabajar",
          label: "wkt.admin.qbuilder.model.monthly-workday.total-work-hours.text",//"H. a trabajar",
          formatter: 'formatTime'
        },
        {
          field: "totalHoursOff",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.total-hours-off.description",//"Horas vacaciones",
          label: "wkt.admin.qbuilder.model.monthly-workday.total-hours-off.text",//"H. vacaciones",
          formatter: 'formatTime'
        },
        {
          field: "totalActivityWorkHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.workday.total-activity-work-hours.description", //"Horas de trabajo",
          label: "wkt.admin.qbuilder.model.workday.total-activity-work-hours.text",  //"H. trabajo",
          formatter: 'formatTime'
        },
        {
          field: "adjustmentHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.workday.adjustment-hours.description", //"Ajuste horas de trabajo",
          label: "wkt.admin.qbuilder.model.workday.adjustment-hours.text",  //"Ajuste H. T.",
          formatter: 'formatTime'
        },
        {
          field: "finalActivityWorkHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.final-activity-work-hours.description",//"Total Horas Trabajadas",
          label: "wkt.admin.qbuilder.model.monthly-workday.final-activity-work-hours.text",//"Total H. T.",
          formatter: 'formatTime'
        },
        {
          field: "workBalance",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.work-balance.description",//"Balance de horas trabajadas con respecto a las objetivo",
          label: "wkt.admin.qbuilder.model.monthly-workday.work-balance.text",//"Balance Horas",
          formatter: 'formatTime'
        },
        {
          field: "workBalanceHours",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.monthly-workday.work-balance_hours.description",//"Balance de horas trabajadas con respecto a las objetivo",
          label: "wkt.admin.qbuilder.model.monthly-workday.work-balance_hours.text",//"Balance en Horas",
          formatter: 'formatFloat'
        },
        {
          field: "totalActivityNonWorkHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.workday.total-activity-non-work-hours.description", //"Horas personales",
          label: "wkt.admin.qbuilder.model.workday.total-activity-non-work-hours.text",  //"H. personales",
          formatter: 'formatTime'
        },
        {
          field: "adjustmentNonWorkHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.workday.adjustment-non-work-hours.description", //"Ajuste horas personales",
          label: "wkt.admin.qbuilder.model.workday.adjustment-non-work-hours.text",  //"Ajuste H. P.",
          formatter: 'formatTime'
        },
        {
          field: "finalActivityNonWorkHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.final-activity-non-work-hours.description",//"Total Horas Personales",
          label: "wkt.admin.qbuilder.model.monthly-workday.final-activity-non-work-hours.text",//"Total H. P.",
          formatter: 'formatTime'
        },
        {
          field: "extraHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.workday.extra-hours.description", //"Horas extra",
          label: "wkt.admin.qbuilder.model.workday.extra-hours.text",  //"H. extra",
          formatter: 'formatTime'
        },
        {
          field: "adjustamentExtraHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.workday.adjustament-extra-hours.description", //"Ajuste horas extra",
          label: "wkt.admin.qbuilder.model.workday.adjustament-extra-hours.text",  //"Ajuste H. E.",
          formatter: 'formatTime'
        },
        {
          field: "finalExtraHours",
          type: "TIME",
          desc: "wkt.admin.qbuilder.model.monthly-workday.final-extra-hours.description",//"Total Horas Extra",
          label: "wkt.admin.qbuilder.model.monthly-workday.final-extra-hours.text",//"Total H. E.",
          formatter: 'formatTime'
        },
        {
          field: "workdayActivityStart",
          type: "DATETIME",
          desc: "wkt.admin.qbuilder.model.workday.workday-activity-start.description", //"Hora de inicio de actividad",
          label: "wkt.admin.qbuilder.model.workday.workday-activity-start.text",  //"Inicio actividad",
          formatter: 'formatDateTime'
        },
        {
          field: "workdayActivityFinish",
          type: "DATETIME",
          desc: "wkt.admin.qbuilder.model.workday.workday-activity-finish.description", //"Hora de fin de actividad",
          label: "wkt.admin.qbuilder.model.workday.workday-activity-finish.text",  //"Fin actividad",
          formatter: 'formatDateTime'
        },
        {
          field: "isUpdated",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.workday.updated.description",//"Jornada modificada",
          label:"wkt.admin.qbuilder.model.workday.updated.text",//"Modificado",
          formatter: 'formatChoice',
          choices: [ { 'key':'1', 'value':'wkt.admin.common.yes'/*'Si'*/ },
                     { 'key':'0', 'value':'wkt.admin.common.no'/*'No'*/ } ]
        }
      ],
}